"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebmFloat = void 0;
const WebmBase_1 = require("./WebmBase");
class WebmFloat extends WebmBase_1.WebmBase {
    constructor(name, start = 0) {
        super(name, start);
    }
    getType() {
        return "Float";
    }
    getFloatArrayType() {
        return this.source && this.source.length === 4 ? Float32Array : Float64Array;
    }
    updateBySource() {
        const byteArray = this.source.reverse();
        const floatArrayType = this.getFloatArrayType();
        const floatArray = new floatArrayType(byteArray.buffer);
        this.data = floatArray[0];
    }
    updateByData() {
        const floatArrayType = this.getFloatArrayType();
        const floatArray = new floatArrayType([this.data]);
        const byteArray = new Uint8Array(floatArray.buffer);
        this.source = byteArray.reverse();
    }
}
exports.WebmFloat = WebmFloat;
//# sourceMappingURL=WebmFloat.js.map